function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var createDelayedQueue = function createDelayedQueue(callback) {
  var test = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return true;
  };
  var maxAttempts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 60;
  var interval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
  // we create the error object at the top level so we get a better stack trace on where this
  // queue was created
  var timeoutError = new Error('Queue request timeout');
  var queue = [];
  var flushing = false;
  var tries = 0;

  var flushQueue = function flushQueue() {
    tries = tries + 1; // if we've failed too many times, give up and reject all of the queue items

    if (tries > maxAttempts) {
      flushing = false;
      tries = 0;
      queue.splice(0).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 3),
            reject = _ref2[2];

        reject(timeoutError);
      });
      return;
    } // if the test still hasn't passed, we want to try again later


    if (!test()) {
      flushing = true;
      setTimeout(flushQueue, interval);
      return;
    }

    flushing = false;
    tries = 0; // flush all the items from the queue
    // the callback might add additional items to the queue
    // so we need to keep trying until the queue is empty
    // if the callback is asynchronous we want to resolve/reject the outer promise
    // when it's complete

    queue.splice(0).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 3),
          data = _ref4[0],
          resolve = _ref4[1],
          reject = _ref4[2];

      try {
        Promise.resolve(callback.apply(void 0, _toConsumableArray(data))).then(resolve, reject);
      } catch (e) {
        reject(e);
      }
    });
  }; // wraps the callback function and reroutes calls to the queue
  // we return a promise that resolves when the queue item is finally run


  var addToQueue = function addToQueue() {
    for (var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++) {
      data[_key] = arguments[_key];
    }

    return new Promise(function (resolve, reject) {
      queue.push([data, resolve, reject]); // we don't want to flush the queue if it's already flushing
      // this could happen if the callback adds more stuff to the queue

      if (!flushing) {
        flushQueue();
      }
    });
  };

  return addToQueue;
};

var createSequentialQueue = function createSequentialQueue(callback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$stopOnError = _ref.stopOnError,
      stopOnError = _ref$stopOnError === void 0 ? false : _ref$stopOnError;

  var master = Promise.resolve(void 0);
  return function () {
    for (var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++) {
      data[_key] = arguments[_key];
    }

    var resolve;
    var reject;
    var p = new Promise(function (res, rej) {
      resolve = res;
      reject = rej;
    }).then(function () {
      return callback.apply(void 0, data);
    });
    master = master.then(function () {
      resolve();
      return p;
    }, function (err) {
      if (stopOnError) {
        reject(err);
      } else {
        resolve();
      }

      return p;
    });
    return p;
  };
};

export { createDelayedQueue, createSequentialQueue };
